import { PlayType, type Play } from '@bbkAdminRedux/rtkq/play.slice';

export { areTargetingNodesEqual } from './play-targeting-utils';

export const DRAWER_ANIMATION_DURATION = 300;

export const generateUniqueDuplicatePlayName = (
  playName: string,
  existingPlays: Play[]
): string => {
  const baseName = `${playName} (Copy)`;
  const existingNames = new Set(existingPlays.map((p) => p.name));

  let duplicatePlayName = baseName;

  if (existingNames.has(duplicatePlayName)) {
    const randomSuffix = Math.floor(Math.random() * 10000);
    duplicatePlayName = `${playName} (Copy ${randomSuffix})`;
  }

  return duplicatePlayName;
};

export const getPlayTypeFromRoute = (
  type: string | undefined
): PlayType | null => {
  if (type === 'expansion') return PlayType.UPSELL;
  if (type === 'acquisition') return PlayType.ACQUISITION;
  if (type === 'retention') return PlayType.RETENTION;
  return null;
};

export const getRouteTypeFromPlayType = (type: string | undefined): string => {
  if (type === PlayType.UPSELL) return 'expansion';
  if (type === PlayType.ACQUISITION) return 'acquisition';
  if (type === PlayType.RETENTION || type === PlayType.CHURN_PREVENTION)
    return 'retention';
  return 'expansion';
};
